/*
 *
 * NewTreatmentPage reducer
 *
 */
import {fromJS} from "immutable";
import {
  CREATE_PATIENT_ACTION,
  CREATE_PATIENT_FAILED_ACTION,
  CREATE_PATIENT_SUCCESS_ACTION,
} from "containers/App/constants";
import * as CONSTANTS from "./constants";

export const initialState = fromJS({
  insurers: [],
  patientLoading: false,

  patient: null,
  patientStepFailed: null,
  treatmentPlan: null,

  timeWindow: null,
  treatments: [],
  treatmentToPlan: null,
  hasPatient: false,
  dontSkip: false,

  // Loading status
  global: false,
  userStep: false,
  treatmentStep: false,
  resultStep: false,

  patientIdLoading: false,
  treatmentPlanIdLoading: false,

  patientUpdateFailed: null,
  patientUpdateLoading: false,

  treatmentLoading: false,
  patientStepInProgress: false,
  loading: true,

  timeSlot: null,
  timeSlotData: null,
  timeSlotDataLoading: false,

  isEditingPlannedTreatment: false,

  checkAvailabilityLoading: false,
  checkAvailabilityFailedMessage: null,

  editingTreatment: false,

  // Planned days
  plannedDays: undefined,
  plannedDaysLoading: false,

  // Treatment duration
  treatmentDuration: undefined,
  treatmentDurationLoading: false,

  // drivers
  drivers: [],
});

function newTreatmentPageReducer(state = initialState, action) {
  switch (action.type) {
    /**
     * Get treatment duration
     */
    case CONSTANTS.GET_TREATMENT_DURATION:
      return state.set("treatmentDurationLoading", true);
    case CONSTANTS.GET_TREATMENT_DURATION_SUCCESS:
      return state
        .set("treatmentDuration", action.duration)
        .set("treatmentDurationLoading", false);
    case CONSTANTS.GET_TREATMENT_DURATION_ERROR:
      return state.set("treatmentDurationLoading", false);
    /**
     * Get treatment plan
     */
    case CONSTANTS.GET_TREATMENT_PLAN:
      return state.set("treatmentLoading", true);
    case CONSTANTS.GET_TREATMENT_PLAN_SUCCESS:
      return state
        .set("treatmentPlan", action.result)
        .set("treatmentLoading", false);
    case CONSTANTS.GET_TREATMENT_PLAN_FAILED:
      return state.set("treatmentLoading", false);
    /**
     * Update patient
     */
    case CONSTANTS.UPDATE_PATIENT:
      return state
        .set("patientUpdateFailed", null)
        .set("patientUpdateLoading", true);
    case CONSTANTS.UPDATE_PATIENT_FAILED:
      return state
        .set("patientUpdateFailed", action.reason)
        .set("patientUpdateLoading", false);
    case CONSTANTS.UPDATE_PATIENT_SUCCESS:
      return state
        .set("patientUpdateFailed", null)
        .set("patientUpdateLoading", false)
        .set("patient", action.result);

    /**
     * Get patient
     */
    case CONSTANTS.GET_PATIENT:
      return state.set("patient", null).set("patientLoading", true);
    case CONSTANTS.GET_PATIENT_FAILED:
      return state.set("patient", null).set("patientLoading", false);
    case CONSTANTS.GET_PATIENT_SUCCESS:
      return state.set("patient", action.result).set("patientLoading", false);

    case CONSTANTS.GET_PLANNED_DAYS:
      return state.set("plannedDaysLoading", true).set("timeSlotData", null);
    case CONSTANTS.GET_PLANNED_DAYS_ERROR:
      return state.set("plannedDaysLoading", false).set("plannedDays", null);
    case CONSTANTS.GET_PLANNED_DAYS_SUCCESS:
      return state
        .set("plannedDaysLoading", false)
        .set("plannedDays", action.result);

    /**
     * Update / create treatment plan
     */
    case CONSTANTS.UPDATE_TREATMENT_PLAN_SUCCESS:
    case CONSTANTS.CREATE_TREATMENT_PLAN_SUCCESS:
      return state.set("treatmentPlan", action.result);
    /**
     * Treatments
     */
    case CONSTANTS.SAVE_TREATMENTS:
      return state.set("treatments", fromJS(action.treatments));
    /**
     * Reset
     */
    case CONSTANTS.SOFT_RESET:
      return initialState
        .set("insurers", state.get("insurers"))
        .set("patient", state.get("patient"));
    case CONSTANTS.HARD_RESET:
      // Fully reset everything, except for the insurers because the list
      // of insures will stay consistent even for a different patient.
      return initialState.set("insurers", state.get("insurers"));

    case CONSTANTS.CONTINUE:
      return state
        .set("hasPatient", true)
        .set("dontSkip", false)
        .set("timeWindow", null)
        .set("treatmentToPlan", null);
    /**
     * Set / remove patient & get patient
     */
    case CONSTANTS.SET_PATIENT:
      return state
        .set("patient", action.patient)
        .set("hasPatient", true)
        .set("dontSkip", action.dontSkip);
    case CONSTANTS.REMOVE_PATIENT:
      return state
        .set("treatmentPlan", null)
        .set("patient", null)
        .set("hasPatient", false)
        .set("dontSkip", false);

    case CONSTANTS.GET_PATIENT_ID:
      return state.set("patientIdLoading", true);
    case CONSTANTS.GET_PATIENT_ID_FAILED:
      return state.set("patientIdLoading", false);
    case CONSTANTS.GET_PATIENT_ID_SUCCESS:
      return state
        .set("patient", action.result)
        .set("hasPatient", true)
        .set("patientIdLoading", false);
    /**
     * Create patient --- App/reducer
     */
    case CREATE_PATIENT_ACTION:
      return state
        .set("patientStepFailed", null)
        .set("patientStepInProgress", true);
    case CREATE_PATIENT_SUCCESS_ACTION:
      return state
        .set("patient", action.result)
        .set("patientStepFailed", null)
        .set("patientStepInProgress", false);
    case CREATE_PATIENT_FAILED_ACTION:
      return state
        .set("patientStepFailed", action.reason)
        .set("patientStepInProgress", false);
    /**
     * save time window
     */
    case CONSTANTS.TIME_WINDOW_ACTION:
      return state.set("timeWindow", action.timeWindow);
    /**
     * TimeSlotData
     */
    case CONSTANTS.GET_TIME_SLOT_DATA:
      return state
        .set("timeSlotDataLoading", true)
        .set("timeSlotData", null)
        .set("plannedDays", null);
    case CONSTANTS.GET_TIME_SLOT_DATA_FAILED:
      return state.set("timeSlotDataLoading", false).set("timeSlotData", null);
    case CONSTANTS.GET_TIME_SLOT_DATA_SUCCESS:
      return state
        .set("timeSlotDataLoading", false)
        .set("timeSlotData", action.result);
    /**
     * CheckAvailabilityData
     */
    case CONSTANTS.CHECK_AVAILABILITY:
      return state
        .set("checkAvailabilityLoading", true)
        .set("checkAvailabilityFailedMessage", null);
    case CONSTANTS.CHECK_AVAILABILITY_FAILED:
      return state
        .set("checkAvailabilityLoading", false)
        .set("checkAvailabilityFailedMessage", action.reason);
    case CONSTANTS.CHECK_AVAILABILITY_SUCCESS:
      return state
        .set("checkAvailabilityLoading", false)
        .set("checkAvailabilityFailedMessage", null);
    /**
     * Other
     */
    case CONSTANTS.IS_EDITING_PLANNED_TREATMENT:
      return state.set("isEditingPlannedTreatment", action.isEditing);
    case CONSTANTS.SELECT_TIME_SLOT: {
      return state.set("timeSlot", action.timeSlot);
    }
    case CONSTANTS.UPDATE_TREATMENT_PLAN_TREATMENT: {
      const treatmentPlan = state.get("treatmentPlan");
      if (!treatmentPlan) {
        return state;
      }

      const { treatment } = action;
      const { plannedTreatments } = treatmentPlan;
      // Find the target treatment
      for (let i = 0; i < plannedTreatments.length; i++) {
        const current = plannedTreatments[i];
        // merge the treatment
        if (current.id === treatment.id) {
          treatmentPlan.plannedTreatments[i] = { ...current, ...treatment };
          return state.set("treatmentPlan", treatmentPlan);
        }
      }

      return state;
    }
    case CONSTANTS.GET_TREATMENT_PLAN_ID:
      return state.set("treatmentPlanIdLoading", true);
    case CONSTANTS.GET_TREATMENT_PLAN_ID_FAILED:
      return state.set("treatmentPlanIdLoading", false);
    case CONSTANTS.GET_TREATMENT_PLAN_ID_SUCCESS:
      return state
        .set("treatmentPlan", action.result)
        .set("treatmentPlanIdLoading", false);
    case CONSTANTS.SET_TREATMENT_TO_PLAN: {
      const copy = { ...action.treatment };
      if (!copy.id) {
        copy.id = copy.id;
      }

      return state.set("treatmentToPlan", copy);
    }

    /**
     * Set treatmentPlan
     */
    case CONSTANTS.SET_TREATMENT_PLAN:
      return state.set("treatmentPlan", action.treatmentPlan);
    /**
     * Editing state
     */
    case CONSTANTS.SET_EDITING_TREATMENT:
      return state.set("editingTreatment", action.editing);

    case CONSTANTS.GET_TREATMENT_DRIVERS_SUCCESS:
      return state.set("drivers", action.drivers);

    // case CONSTANTS.SELECT_UNPLANNED: {
    //   const treatmentPlan = state.get("treatmentPlan");
    //   for (const treatment of treatmentPlan.plannedTreatments) {
    //     if (!treatment.planned) {
    //       treatment.above = action.above;
    //       treatment.below = action.below;
    //     }
    //   }
    //   return state.set("treatmentPlan", treatmentPlan);
    // }
    case CONSTANTS.DEFAULT_ACTION:
      return state;
    default:
      return state;
  }
}

export default newTreatmentPageReducer;
